module.exports = __webpack_public_path__ + "a6db5b9ec50a87602ab130f1ffd25808.svg";